export default "__VITE_ASSET__D3ho3YEI__"